import React from 'react';
import { forwardRef } from 'react';
import { StyledLabel, StyledInput, StyledBox, StyledIcon, StyledAppendix, StyledTextContent, StyledCheckboxContainer, StyledFormMessage } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Checkbox = forwardRef(({ className, label, id, checked, defaultChecked, value, appendix, disabled, name, required, invalid, onChange, onKeyDown, errorMessage, onClick, hint, margin, ...rest }, ref) => {
    const hintId = `${id}__hint`;
    const errorMsgId = `${id}__error-msg`;
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const ariaDescribedByFromProps = a11yProps['aria-describedby'];
    const ariaDescribedBy = [
        hint ? hintId : undefined,
        errorMessage && invalid ? errorMsgId : undefined,
        ariaDescribedByFromProps
    ]
        .filter(Boolean)
        .join(' ')
        .trim();
    return (React.createElement(StyledCheckboxContainer, { className: className, ref: ref, margin: margin, ...dataProps },
        React.createElement(StyledLabel, { invalid: invalid, disabled: disabled },
            React.createElement(StyledInput, { type: "checkbox", checked: checked, defaultChecked: defaultChecked, id: id, value: value, disabled: disabled, required: required, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, name: name, invalid: invalid, ...a11yProps, "aria-describedby": ariaDescribedBy || undefined }),
            React.createElement(StyledBox, null,
                React.createElement(StyledIcon, { name: "select", size: "xs" })),
            React.createElement(StyledTextContent, null,
                label,
                appendix && (React.createElement(StyledAppendix, { "$disabled": disabled }, appendix)))),
        hint && (React.createElement(StyledFormMessage, { text: hint, variant: "hint", id: hintId, disabled: disabled })),
        invalid && errorMessage && (React.createElement(StyledFormMessage, { text: errorMessage, variant: "error", id: errorMsgId }))));
});
Checkbox.displayName = 'Checkbox';
//# sourceMappingURL=index.js.map